import template from './assetInsuranceSection.html';
import controller from './assetInsuranceSectionCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isLodged: '<',
    loanAppId: '<',
    familyId: '<',
  },
};
